const PHOTOS = [
  { url: "https://images.pexels.com/photos/8448068/pexels-photo-8448068.jpeg", label: "Taco al pastor", span: "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto" },
  { url: "https://images.unsplash.com/photo-1760322327968-d5a0184003bb", label: "Suadero", span: "aspect-square" },
  { url: "https://images.unsplash.com/photo-1719948515819-71265e1abb0d", label: "Campechano", span: "aspect-square" },
  { url: "https://images.pexels.com/photos/5201109/pexels-photo-5201109.jpeg", label: "Volcanes", span: "aspect-square" },
  { url: "https://images.pexels.com/photos/34109691/pexels-photo-34109691.jpeg", label: "Exterior", span: "md:col-span-2 aspect-square md:aspect-[2/1]" },
  { url: "https://images.pexels.com/photos/14758354/pexels-photo-14758354.jpeg", label: "Por la noche", span: "aspect-square" },
  { url: "https://images.pexels.com/photos/19250418/pexels-photo-19250418.jpeg", label: "La plancha", span: "aspect-square" },
  { url: "https://images.pexels.com/photos/28992999/pexels-photo-28992999.jpeg", label: "El trompo", span: "md:col-span-2 aspect-square md:aspect-[2/1]" },
];

export default function Galeria() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-12">
        <div className="text-xs uppercase tracking-[0.25em] text-brand font-semibold mb-3">Galería</div>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tight leading-[0.95]">Pásale un ojito.<br />Y luego, el paladar.</h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {PHOTOS.map((p, i) => (
            <figure key={i} className={`relative overflow-hidden rounded-2xl bg-zinc-100 group ${p.span}`}>
              <img src={p.url} alt={p.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-white text-sm font-semibold">
                {p.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
}
